// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"a8776ed056186864","4044":"ed7d2b6abeab1867","4515":"a8776ed056186864","4969":"b8fa7670bd57952b","5264":"6a329769f3603c19","8378":"3adc4bd9af4bfe6d"}[chunkId] + ".css";
};